import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  padding: 0px 20px 80px 20px;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  align-self: stretch;

  .content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    align-self: stretch;
  }
`;

export const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 80px;
  align-self: stretch;
`;

export const SettingSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;

  .header {
    display: flex;
    padding: 0px 24px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }

  .label {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
`;
